export default __webpack_public_path__ + "2b0583880b6117f662b9bad183dc5647.png";